export default __webpack_public_path__ + "static/media/course-testimonial.d002bf50.webp";